<template>
  <StationMonitor :tabs="[/* '智能告警', */ '告警信息', '数据分析', '远程开关机', /* '高级策略配置' */]" />
</template>

<script setup lang="ts">
import StationMonitor from '@/views/station-monitor/detail/index.vue'
import { ref, reactive, computed, onMounted, onUnmounted, watch } from 'vue'
const data = reactive({

})
</script>

